<template>
    <div>
        <v-expand-transition>
            <div v-if="expand == false">
                <v-form ref="formEvaluacionPregunta" lazy-validation>
                    <v-row>

                        <v-col cols="auto">
                            <TableButtonComp normalButton @click="EventListQuestion();" textButton="Listar Preguntas"
                                icon-but="far fa-list-alt" />
                        </v-col>

                        <v-col cols="auto">
                            <TableButtonComp normalButton @click="EventAddQuestion();" textButton="Agregar preguntas"
                                icon-but="fas fa-plus" />
                        </v-col>

                        <v-col cols class="text-end">
                            <TableButtonComp normalButton @click="ViewQuestionEval();" classColor="green"
                                textButton="Ver Evaluación" icon-but="fas fa-eye" />
                        </v-col>

                        <v-col cols="12">
                            <ComundataTablecomp :headers="headers" :items="listaPreguntasArray" :search="search"
                                :sort-by="['nombre_template']" :sort-desc="[false]">

                                <template v-slot:titulo="{ item }">
                                    <span v-html="item.titulo"></span>
                                </template>

                                <template v-slot:pregunta="{ item }">
                                    <span>{{ item.pregunta | quitarTag }}</span>
                                </template>

                                <template v-slot:action_orden="{ item }">
                                    <v-text-field type="number" v-model="item.orden"> </v-text-field>
                                </template>

                                <template v-slot:action_valor="{ item }">
                                    <v-select v-model="item.id_valor" :items="listCalificacionEvaluacion"
                                        item-value="id" item-text="calificacion" :disabled="inhabilitar">
                                    </v-select>
                                </template>

                                <template v-slot:action_ver="{ item }">
                                    <v-tooltip bottom color="#1b1b1b">
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                v-if="componenteEvento.editar_submodulo && componenteUsuario.editar_submodulo"
                                                v-on="on" class="btn_ver px-0 mx-0" fab x-small @click="viewItem(item)">
                                                <v-icon>fa-eye</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>VER PREGUNTA</span>
                                    </v-tooltip>
                                </template>
                            </ComundataTablecomp>


                        </v-col>
                    </v-row>

                    <v-card-actions class="px-0 pb-0">
                        <v-tooltip right color="#1b1b1b">
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" @click="refresh();" icon color="green">
                                    <v-icon>fas fa-sync</v-icon>
                                </v-btn>
                            </template>
                            <span>Limpiar tabla de preguntas</span>
                        </v-tooltip>
                        <v-spacer class="px-0"></v-spacer>
                        <!-- <v-btn class="btn_block_style2"  v-if="this.evento=='edit'" @click="SaveItem();" >Guardar Cambios</v-btn> -->
                        <!-- <v-btn class="btn_block_style2"  v-if="this.evento=='add'" @click="SaveItem();">Guardar</v-btn> -->
                        <TableButtonComp normalButton @click="nextStep();" textButton="Siguiente" iconBut="" />
                    </v-card-actions>

                </v-form>
            </div>
        </v-expand-transition>
        <v-expand-transition>
            <div v-if="expand == true" class="d-flex transition-fast-in-fast-out v-card--reveal">
                <v-row dense>
                    <v-col cols="12">
                        <component :is="compName" :estadoComp="estadoModalConfig" :parametros="parametroConfig"
                            @close="CloseComp">
                        </component>
                    </v-col>
                </v-row>
            </div>
        </v-expand-transition>
        <!-- <v-tabs style="display: none;" v-model="tab">
            <v-tabs-slider></v-tabs-slider>
            <v-tab href="#tab-1">
            </v-tab>
            <v-tab href="#tab-2">
            </v-tab>
        </v-tabs> -->

        <!-- <v-tabs-items v-model="tab">
            <v-tab-item value="tab-1">

            </v-tab-item>
            <v-tab-item :value="'tab-2'">
            </v-tab-item>
        </v-tabs-items> -->
    </div>
</template>


<script>
import axios, { API_URL } from '@/helpers/axios'
import { mapMutations, mapGetters, mapState, mapActions } from "vuex";
import PreguntaComp from '../PreguntasEval/pregunta.vue'
import PreguntaFormComp from '../PreguntasEval/preguntaFormComp.vue'
import VisorEvaluacionComp from '../../../VisorEvaluacion/visorEvaluacion.vue'
import TableButtonComp from '../../../../../components/ComponentsEst/TableButtonComp.vue'
import ComundataTablecomp from '../../../../../components/ComponentsEst/ComundataTablecomp.vue';



export default {
    name: "evaluacionPreguntas",
    components: {
        PreguntaComp,
        VisorEvaluacionComp,
        PreguntaFormComp,
        TableButtonComp,
        ComundataTablecomp
    },
    props: {
        parametros: {
            type: Object
        },
        estadoComp: {
            type: Boolean
        },
        estadoValidacion: {
            type: Boolean
        },
        wizardChange: {
            type: Number
        }
    },
    data: () => ({
        paramComponente: { "id_modulo": 8, 'id_submodulo': 96 },
        tab: null,
        datoLogin: sessionStorage,
        ruta_api: API_URL,
        test: false,
        tabIndex: 1,
        expand: false,
        compName: null,
        estadoModalConfig: false,
        parametroConfig: [],
        evento: null,
        dataPreguntas: [],
        datosPreg: [],

        listCalificacionEvaluacion: [],
        inhabilitar: true,
        search: '',
        headers: [
            { text: 'PREGUNTA', value: 'pregunta', sortable: false, class: 'header_datatable' },
            { text: 'TIPO DE RESPUESTA', value: 'tipo_pregunta', sortable: false, class: 'header_datatable' },
            { text: 'DIFICULTAD', value: 'dificultad', sortable: false, class: 'header_datatable' },
            { text: 'ORDEN', value: 'action_orden', sortable: false, class: 'header_datatable' },
            { text: 'VALOR DE LA PREGUNTA', sortable: false, value: 'action_valor', class: 'header_datatable' },
        ],
        activeObserver: false,
    }),
    mounted() {
        this.LoadMain()
    },
    computed: {
        ...mapGetters({
            componenteEvento: 'login/componenteEvento',
        }),
        ...mapState({
            listaPreguntasArray: state => state.gestEvaluacion.listaPreguntasArray,
        }),
    },
    watch: {
        estadoComp(flag) {
            if (flag) {
                this.evento = null;
                this.LoadMain();
            } else {
                this.refresh()
            }
        },
        estadoValidacion(flag) {
            if (flag) {
                this.validarDatos();
            }
        },
        // dataPreguntas() {
        //     this.activeObserver == true ? this.validarDatos() : null;
        // },
        wizardChange(step) {
            if (step == 2) {
                // console.log('este paso se dejo atras y se valida campos', step);
            }
        }
    },
    filters: {
        quitarTag: function (value) {
            if (!value) return '';
            // Eliminar etiquetas HTML
            value = value.replace(/<\/?[^>]+>/ig, " ");
            // Convertir entidades HTML a caracteres normales
            var parser = new DOMParser();
            var dom = parser.parseFromString(
                '<!doctype html><body>' + value,
                'text/html'
            );
            return dom.body.textContent;
        },
    },
    methods: {
        ...mapMutations({
            setEnviarMens: "mensajeSis/setEnviarMens",
            setlistaPreguntas: "gestEvaluacion/setlistaPreguntas",
        }),
        ...mapActions({
            parametroComponente: "login/parametroComponente",
            validateForm: "gestEvaluacion/validateForm",
            changeTituloStep: "gestEvaluacion/changeTituloStep",
        }),
        /** 
         __________________________
        |  MÉTODO CARGA INICIAL  */
        async LoadMain() {

            switch (this.parametros.evento) {

                case 'add':
                    this.AddItem();
                    break;

                case 'edit':
                    this.EditItem();
                    break;

            }

            this.GetEscalaEvaluativa();
        },
        /** 
         ________________________________
        |  MÉTODO EMIT SIGUIENTE PASO  */
        validarDatos() {
            // this.dataPreguntas = this.listaPreguntasArray;
            if (this.listaPreguntasArray.length == 0) {
                this.validateForm({ index: 1, value: false });
            } else {
                this.validateForm({ index: 1, value: true });
            }
        },
        /** 
         ________________________________
        |  MÉTODO EMIT SIGUIENTE PASO  */
        async nextStep() {

            // console.log('que abra aqui', this.dataPreguntas);

            // this.setlistaPreguntas(this.dataPreguntas)

            // this.dataPreguntas || this.listaPreguntasArray
            // let params = { id_usuario: this.datoLogin.id, items: this.dataPreguntas }
            this.$emit('wizardNext', 2);
        },
        /** 
         ________________________________
        |  MÉTODO EMIT SIGUIENTE PASO  */
        async GetPreguntaEval() {

            try {

                let filter = { id_evaluacion: this.parametros.items.id, id_colegio: this.parametros.items.id_colegio }
                let response = await axios.post(`/evaluacion/pregunta/view/`, { filter })

                const bancoPreguntas = response.data.map(item => {
                    return { ...item, id: item.id_banco_pregunta }
                })
                // this.dataPreguntas = bancoPreguntas;
                this.setlistaPreguntas(bancoPreguntas);

                // let preguntaEval = response.data
                // if (this.parametros.items.tipo_calificacion == 'L') {
                //     // this.inhabilitar = true
                //     let id_valor = this.parametros.items.id_calificacion_evaluacion
                //     const dataNew = preguntaEval.map((obj) => {
                //         obj.pregunta = this.decodeHTMLEntities(obj.pregunta);
                //         obj.id_valor = id_valor
                //         return obj;
                //     });
                //     this.dataPreguntas = dataNew
                // } else {
                //     this.dataPreguntas = preguntaEval
                // }

            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }
        },
        /** 
         _____________________________
        |  MÉTODO ESCALA EVALUATIVA */
        async GetEscalaEvaluativa() {
            try {
                let params = {
                    id_colegio: this.parametros.items.id_colegio, id_ano_lectivo: this.parametros.items.id_ano_lectivo,
                    id_nivel: this.parametros.items.id_nivel, id_grado: this.parametros.items.id_grado
                }

                let response = await axios.post(`/evaluacion/programacion/escalaEvaluativaGrado/`, { filter: params })
                if (response.data.escalaEvaluacion.length == 0) {
                    this.setEnviarMens({ tipo: "E", mensaje: `No se configuro la escala evaluativa para el grado`, tiempo: 8000 })
                    return
                }
                this.listCalificacionEvaluacion = response.data.notaEvaluacion

            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }
        },
        /** 
         _________________________
        |  MÉTODO FORMATEA HTML */
        decodeHTMLEntities(text) {
            var textArea = document.createElement('textarea');
            textArea.innerHTML = text;
            return textArea.value;
        },
        /** 
         ______________________________
        |  MÉTODO CAMBIAR COMPONENTE */
        EventListQuestion() {
            this.parametros.items.id_docente = this.parametros.items.id_profesor
            this.parametros.items.id_evaluacion = this.parametros.items.id_profesor;
            this.parametros.items.id_evaluacion = this.parametros.items.id;
            this.parametros.items.id_valor = this.listCalificacionEvaluacion[0].id;

            this.expand = true;
            // this.setEnviarMens({tipo:"W", mensaje: `Listar Pregunta`, tiempo:null})
            this.parametroConfig = { evento: "listar", items: this.parametros.items };
            this.compName = "PreguntaComp";
            this.estadoModalConfig = true;
            this.changeTituloStep({ index: 1, title: 'Selecciona preguntas' });
            // this.tab = 'tab-2';
            // this.$emit('wizardNext', -2);
        },
        /** 
         ___________________________
        |  MÉTODO AÑADIR PREGUNTA */
        EventAddQuestion() {
            this.parametros.items.id_valor = this.listCalificacionEvaluacion[0].id;
            this.parametros.items.id_docente = this.parametros.items.id_profesor;
            this.parametroConfig = { evento: "add", items: this.parametros.items };
            this.compName = "PreguntaFormComp"
            this.expand = true;
            // this.tab = 'tab-2';
            this.estadoModalConfig = true;
        },
        /** 
         ________________________
        |  MÉTODO VER PREGUNTA */
        ViewQuestionEval() {
            let params = {
                id_evaluacion: this.parametros.items.id,
                id_colegio: this.parametros.items.id_colegio,
                id_profesor: this.parametros.items.id_profesor,
                id_persona: this.parametros.items.id_persona,
                id_forma_evaluacion: this.parametros.items.id_forma_evaluacion,
                id_calificacion_evaluacion: this.parametros.items.id_calificacion_evaluacion,
                id_valor: this.listCalificacionEvaluacion[0].id
            }
            this.parametroConfig = { evento: "view", items: params };
            this.compName = "VisorEvaluacionComp";
            this.expand = true
            // this.tab = 'tab-2';
            this.estadoModalConfig = true;
        },
        /** 
         ___________________________
        |  MÉTODO OPEN MODAL FORM */
        AddItem() {
            // this.dataPreguntas = this.listaPreguntasArray;
        },
        /** 
         ______________________________________________
        |          MÉTODO EDITAR MODAL FORM          */
        EditItem() {
            // this.listaPreguntasArray.length == 0
            if (this.evento == null) {
                this.GetPreguntaEval();
            }
        },
        /** 
         ______________________________
        |  MÉTODO GUARDAR MODAL FORM */
        // async SaveItem() {
        //     if (this.$refs.formEvaluacionPregunta.validate()) {

        //         try {
        //             let res = {}
        //             if (this.evento == 'add' || this.evento == 'edit') {
        //                 let params = { id_usuario: this.datoLogin.id, items: this.dataPreguntas }
        //                 res = await axios.put("/evaluacion/pregunta/masivo/" + this.parametros.items.id, params)
        //             }
        //             this.setEnviarMens({ tipo: res.data.messageT, mensaje: res.data.message, tiempo: null })

        //             if (res.data.messageT == "S") {
        //                 this.$emit('reloadComp')
        //                 this.$emit('wizardNext', this.tabIndex)
        //             }
        //         }
        //         catch (error) {
        //             this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
        //         }

        //     }
        // },
        /** 
         ______________________________________________
        |          MÉTODO CERRAR MODAL FORM          */
        CloseComp() {
            this.evento = 'listar';
            this.estadoModalConfig = false
            // this.activeObserver = true;
            this.expand = false;
            // this.tab = 'tab-1';
            this.changeTituloStep({ index: 1, title: 'Agregar preguntas' });
            this.LoadMain()
        },
        refresh() {
            // this.activeObserver == true
            // this.validateForm({ index: 1, value: true });
            // this.dataPreguntas = []
            this.setlistaPreguntas([])
            this.estadoModalConfig = false
        }
    }
};
</script>
<style scoped>
.text {
    font-size: 1.2em !important;
}
</style>